import { useEffect } from 'react'
import { googleMapsConfigured, loadGoogleMaps } from './googleMaps'

type Center = {lat:number;lng:number}
type GoogleMapsApi = {
  Map: new (element:HTMLElement, options:Record<string,unknown>) => unknown
}

const nightStyle:Record<string,unknown>[]=[
  {elementType:'geometry',stylers:[{color:'#100d1d'}]},
  {elementType:'labels.text.fill',stylers:[{color:'#777188'}]},
  {elementType:'labels.text.stroke',stylers:[{color:'#100d1d'}]},
  {featureType:'administrative',elementType:'geometry',stylers:[{visibility:'off'}]},
  {featureType:'poi',stylers:[{visibility:'off'}]},
  {featureType:'road',elementType:'geometry',stylers:[{color:'#282333'}]},
  {featureType:'road',elementType:'labels.icon',stylers:[{visibility:'off'}]},
  {featureType:'transit',stylers:[{visibility:'off'}]},
  {featureType:'water',elementType:'geometry',stylers:[{color:'#102237'}]},
]

/**
 * Google Maps viene montata imperativamente nel canvas perché l'SDK possiede
 * il proprio DOM. Marker, cluster e scheda restano componenti DROP accessibili.
 */
export function useGoogleMapsCanvas(active:boolean,center:Center) {
  useEffect(()=>{
    if(!active||!googleMapsConfigured())return
    const host=document.querySelector<HTMLElement>('.map-canvas')
    if(!host)return
    const layer=document.createElement('div')
    layer.className='google-map-layer'
    layer.setAttribute('aria-hidden','true')
    host.prepend(layer)
    let mounted=true
    loadGoogleMaps().then(value=>{
      if(!mounted)return
      const maps=value as GoogleMapsApi
      new maps.Map(layer,{center,zoom:12,disableDefaultUI:true,clickableIcons:false,keyboardShortcuts:false,gestureHandling:'greedy',backgroundColor:'#100d1d',styles:nightStyle})
      host.classList.add('google-ready')
    }).catch(()=>host.classList.remove('google-ready'))
    return()=>{mounted=false;host.classList.remove('google-ready');layer.remove()}
  },[active,center.lat,center.lng])
}
